import { invoke } from '@vueuse/core'

export default defineNuxtRouteMiddleware(async () => {
  const { isSignedIn } = useUser()

  invoke(async () => {
    await until(() => isSignedIn.value).toMatch((v) => typeof v === 'boolean')

    if (!isSignedIn.value) {
      const clerk = useClerk()
      const toast = useToast()

      toast.add({
        color: 'red',
        title: 'Please sign in to view this page.',
      })

      await clerk.value?.redirectToSignIn()
    }
  })
})
